import { Component, OnInit, ViewChild, TemplateRef } from '@angular/core';
import {MatPaginator} from '@angular/material/paginator';
import {MatTableDataSource} from '@angular/material/table';
import {MatSortModule, MatSort} from '@angular/material/sort';
import { Router, ActivatedRoute } from '@angular/router';
@Component({
  selector: 'app-view-candidates',
  templateUrl: './view-candidates.component.html',
  styleUrls: ['./view-candidates.component.scss']
})
export class ViewCandidatesComponent implements OnInit {
  candidates: any=[];
  displayedColumns: string[] = ['S.No.','First_Name','Roll_Number','Department','UG_CGPA','Twelfth_Std_Mark'];
  @ViewChild(MatSort, {static: true}) sort: MatSort;
  @ViewChild(MatPaginator, {static: true}) paginator: MatPaginator;
  @ViewChild("content") modalContent: TemplateRef<any>;
  searchKey: string;
  dataSource: MatTableDataSource<any>;
  collegename: any;
  yearname: any;
  user;
  fname;
  lname;
  userEvaluator: boolean;
  userAdmin: boolean;
  userSuperAdmin: boolean;
  userTestScheduler: boolean;
  constructor(private router: Router) { }

  ngOnInit(): void {
    // this.section_button=JSON.parse(localStorage.getItem('section_button'));
    this.candidates=JSON.parse(localStorage.getItem('Candidates'));
    console.log("this.candidates",this.candidates)
    this.getAccess()
    if(this.candidates != [])
    {
      this.collegename=this.candidates[0].College_Name;
      this.yearname=this.candidates[0].Year;
      this.dataSource = new MatTableDataSource(this.candidates);
      console.log("datasource",this.dataSource)
      this.dataSource.sort=this.sort;

      setTimeout(() => this.dataSource.paginator = this.paginator);
    }

  }

  getAccess(){
    this.user = sessionStorage.getItem('user');
    this.fname = sessionStorage.getItem('fname');

    this.lname = sessionStorage.getItem('lname');


    if (this.user === '1') {
      this.userAdmin = true;
      this.userTestScheduler = false;
      this.userEvaluator = false;
    } else if (this.user === '2') {
      this.userEvaluator = true;
      this.userAdmin = false;
      this.userTestScheduler = false;
    } else if (this.user === '3') {
      this.userTestScheduler = true;
      this.userAdmin = false;
      this.userEvaluator = false;  
    }
  }
  display_candid(){
   window.location.reload();
  }
  onSearchClear() {
    this.searchKey = "";
    this.applyFilter();
  }
  back(){
    this.router.navigate(['test_taker']);
  }

  applyFilter() {
    this.dataSource.filter = this.searchKey.trim().toLowerCase();
  }

}
